module.exports = __webpack_public_path__ + "img/198643.20bea05a.jpg";